import {
  OriginatingCountrySchema,
  PhoneNumberProvider,
  PhoneNumberUseCase,
  TextMessagingVerificationStatus,
} from "@redotech/redo-common-model/phone/phone-number";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const createPhoneNumber = {
  name: "createPhoneNumber" as const,
  input: z.object({
    team: z.string(),
    number: z.string(),
    provider: createEnum(PhoneNumberProvider),
    useCase: createEnum(PhoneNumberUseCase),
    verificationStatus: createEnum(TextMessagingVerificationStatus),
    originatingCountry: OriginatingCountrySchema,
  }),
  output: z.null(),
};
